import { Controller } from '@hotwired/stimulus'
import Cropper from 'cropperjs'

/* global FileReader */

export default class extends Controller {
  static targets = ['input', 'image', 'cropX', 'cropY', 'cropWidth', 'cropHeight',
    'form', 'cropperContainer']

  connect () {
    this.cropper = null
  }

  disconnect () {
    if (this.cropper) {
      this.cropper.destroy()
      this.cropper = null
    }
  }

  handleFileSelect (event) {
    const files = event.target.files
    if (files.length === 0) return

    const file = files[0]
    const reader = new FileReader()
    reader.onload = (e) => {
      this.imageTarget.src = e.target.result
      this.cropperContainerTarget.classList.remove('hidden')

      if (this.cropper) {
        this.cropper.destroy()
      }

      this.cropper = new Cropper(this.imageTarget, {
        aspectRatio: 5,
        viewMode: 1
      })
    }
    reader.readAsDataURL(file)
  }

  handleSubmit (event) {
    event.preventDefault()
    if (this.cropper) {
      const cropData = this.cropper.getData(true)
      this.cropXTarget.value = cropData.x
      this.cropYTarget.value = cropData.y
      this.cropWidthTarget.value = cropData.width
      this.cropHeightTarget.value = cropData.height
    }
    this.formTarget.submit()
  }
}
